import styled from 'styled-components';

export const EmptyHeaderBlockOnBlackPageStyles = styled.div`
  position: absolute;
  top: 0;
  height: 80px;
  width: 100%;
  background: #000;
`;
